import HomeIcon from "@material-ui/icons/Home";
import CodeIcon from '@material-ui/icons/Code';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';

export const links = [
  {
    id: 1,
    name: 'Home',
    url: '/',
    icon: HomeIcon
  },
  {
    id: 2,
    name: 'Projects',
    url: '/projects',
    icon: CodeIcon
  },
  {
    id: 3,
    name: 'Experience',
    url: '/experience',
    icon: WorkOutlineIcon
  },
  {
    id: 4,
    name: 'Contact',
    url: '/contact',
    icon: AlternateEmailIcon
  },
]